import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import {
  type ExtendedBuildingBlockNodeConfig,
  type ExtendedRootNodeConfig,
  NodeType,
} from '@nodeTypeConfig/configTypes';
import { proThemeTocTypes } from '@nodeTypeConfig/helpers/buildingBlocks/proThemeTocTypes';
import { proAliasesComponent } from '@nodeTypeConfig/helpers/editComponents/proAliasesComponent';
import { proContentTypeForDatabasePicker } from '@nodeTypeConfig/helpers/editComponents/proContentTypeForDatabasePicker';
import { proDocumentStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { proLinksAndMenuReferences } from '@nodeTypeConfig/helpers/editComponents/proLinksAndMenuReferences';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { proTileStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proTileStandardComponents';
import {
  asideWebBasicConfiguration,
  asideWebFacetConfiguration,
} from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import {
  proThemeDefaultValidationRules,
  proTileDefaultValidionRules,
} from '../proGenericConfigProps';

const proDatabase = {
  nodeSelector: selectTitleWithDescriptionNode,
  information: {
    description:
      'Pro Database (webTemplate code MINI_DATABASE) can be a SECTION (a tile) in a home or can be the root (single page pro theme)',
    single: 'PRO.-tegel: Databank',
    plural: 'Databanken',
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  buildingBlocks: proDefaultBuildingBlocks,
  webTab: [...asideWebBasicConfiguration, ...asideWebFacetConfiguration],
};

// Extends SECTION => A SECTION inside a Pro Theme and WebConfig MINI_DATABASE becomes a PRO_DATABASE_TILE
export const PRO_DATABASE_TILE: ExtendedBuildingBlockNodeConfig = {
  ...proDatabase,
  validationRules: proTileDefaultValidionRules,
  ...extendsSection,
  isCollapsedByDefault: true,
  edit: [
    ...proTileStandardComponents,
    proAliasesComponent,
    proContentTypeForDatabasePicker,
    ...proLinksAndMenuReferences,
  ],
  addAccessRightsToAudienceTab: true,
  confirmDelete: true,
};

// Extends WEBPAGE2 => When adding MINI_DATABASE WebConfig to a WEBPAGE2 it becomes a PRO_DATABASE_STANDALONE
export const PRO_DATABASE_STANDALONE: ExtendedRootNodeConfig = {
  ...proDatabase,
  validationRules: proThemeDefaultValidationRules,
  information: {
    ...proDatabase.information,
    definiteArticle: true,
    single: 'PRO.-thema: Database',
  },
  extends: NodeType.WEBPAGE2,
  tocTypes: proThemeTocTypes,
  edit: [
    ...proDocumentStandardComponents,
    proAliasesComponent,
    proContentTypeForDatabasePicker,
    ...proLinksAndMenuReferences,
  ],
  audienceTab: proThemeAudienceTab,
  addAccessRightsToAudienceTab: true,
};
